import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import { green } from "@material-ui/core/colors";

export const useStyles = makeStyles((theme) => ({
  selectorBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    marginLeft: 10,
    marginRight: 10,
    [theme.breakpoints.down("md")]: {
      marginLeft: 0,
      marginRight: 0,
    },
  },
}));

export const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    "&$checked": {
      color: "#658D1B",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

export const theme = (theme) => ({
  ...theme,
  borderRadius: 0,
  colors: {
    ...theme.colors,
    primary25: "#c1c1c1",
    primary: "#658D1B",
    neutral70: "white",
    neutral0: "white",
    dangerLight: "#658D1B",
    danger: "white",
  },
});

export const errorTheme = (theme) => ({
  ...theme,
  borderRadius: 0,
  colors: {
    ...theme.colors,
    primary25: "#c1c1c1",
    primary: "red",
    neutral70: "white",
    neutral0: "white",
    dangerLight: "red",
    danger: "white",
  },
});
